import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from "@angular/core";
import {
  AbstractControl,
  FormGroup,
  FormBuilder,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { ApiCall } from "@shared/async-services/http/api-call.service";
import storageService from "@shared/storage/storageService";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { CookieService } from 'ngx-cookie-service';
import { TranslateService } from "@ngx-translate/core";
import { CommonService } from "@shared/services/common.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginComponent implements OnInit {
  public loginForm: FormGroup;
  hide: boolean = false;
  token: any;
  public submitted = false;
  userName:any;
  pwd:any;
  currentUser:any={}
  roleId:any;
  roles=[1,2,3,4];
  showSpinner : boolean  = false;
  loginErrorToaster: any;
  loginSuccessToaster: any;
  selectedLanguage: any;
  languages: any;

  constructor(
    private fb: FormBuilder,
    private auth: ApiCall,
    private router: Router,
    private toastr: ToastrService,
    public dialog: MatDialog,
    private cookieService: CookieService,
    private dialogRef: MatDialogRef<LoginComponent>,
    private _changeDetectorRef: ChangeDetectorRef,
    public translate: TranslateService,
    public commonService:CommonService,
  ) {}

  ngOnInit() {
    this.loginForm = this.fb.group({
      email: ["",[Validators.required,Validators.email,Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]],
      password: ["", [Validators.required,Validators.minLength(8),Validators.pattern("^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=-_]).*$")]], 
      rememberMe: [false],
    });
    this.getCookiesData();
  }

  get formControl() {
    return this.loginForm.controls;
  }

  onForgetLink() {
    this.router.navigate(["/forget-password"]);
    this.dialogRef.close();
  }

  onLogin() {
    this.showSpinner=true;
    this.submitted = true;
    if (!this.loginForm.valid) {
      this.showSpinner=false;
      return;
    }
    this.auth.loginUser(this.loginForm.value).subscribe(
      (res: any) => {
        if(res.data != null){
        this.showSpinner= false;
        storageService.setItemAsJSON("currentUser", res.data);
        storageService.setItemAsJSON("token", res.data.token);
        this.currentUser= storageService.getItemAsJSON("currentUser");
        this.currentUser.roles.map(role=>this.roleId=role.id);
        this.setDefaultLanguage();
        // this.onLanguageChange();
        if (this.currentUser.token) {
          this.translate.get(['LANDING_PAGE.LOGIN_FORM.LOGIN_SUCCESS_TOASTER'])
              .subscribe(translations => {
                this.loginSuccessToaster = translations['LANDING_PAGE.LOGIN_FORM.LOGIN_SUCCESS_TOASTER'];
              });
          this.showSpinner= false;
          if (this.roleId == this.roles[3]) {
            this.router.navigate(["/assign-accountants"]);
            this.dialogRef.close();
            this.toastr.success(`${this.currentUser.firstName} ${this.loginSuccessToaster}`, "", {
              timeOut: 3000,
            });
          } else if (this.roleId == this.roles[0]) {
            this.router.navigate(["/superadmin/organization"]);
            this.dialogRef.close();
            this.toastr.success(`${this.currentUser.firstName} ${this.loginSuccessToaster}`, "", {
              timeOut: 3000,
            });
          }else if (this.roleId == this.roles[1]){
            this.router.navigate(["/chiefaccountant/dashboard"]);
            this.dialogRef.close();
            this.toastr.success(`${this.currentUser.firstName} ${this.loginSuccessToaster}`, "", {
              timeOut: 3000,
            });
          }else if (this.roleId == this.roles[2]){
            this.router.navigate(["/accountant/my-client"]);
            this.dialogRef.close();
            this.toastr.success(`${this.currentUser.firstName} ${this.loginSuccessToaster}`, "", {
              timeOut: 3000,
            });
          }
        } else {
          this.showSpinner = false; 
          this.toastr.error("User entered invalid Login Credentials!", "");
        }
      }else {
        this.showSpinner = false;
        this._changeDetectorRef.detectChanges();
        this.translate.get(['LANDING_PAGE.LOGIN_FORM.LOGIN_ERROR_MESSAGE'])
              .subscribe(translations => {
              this.loginErrorToaster = translations['LANDING_PAGE.LOGIN_FORM.LOGIN_ERROR_MESSAGE'];
            }); 
        if(res.message === 'User is not active, Please contact administrator.') {
          let text;
          this.translate.get(['USER_NOT_ACTIVE'])
          .subscribe(translations => {
          text = translations['USER_NOT_ACTIVE'];
          });
          this.toastr.error(text, ""); 
        } else {
          this.toastr.error(this.loginErrorToaster, ""); 
        }   
      }
      },
      (err: any) => {
        this.showSpinner = false; 
        console.log("Something went wrong");
      }
    );
  }

  setDefaultLanguage() {
    try {
      this.auth.getSelectedLanguage(this.currentUser.id).subscribe(
        (response: any) => {
          this.selectedLanguage = response.data;
          this.translate.use(this.selectedLanguage.shortName);
          storageService.setItem("language", this.selectedLanguage.shortName);
          this.onLanguageChange();
        },
        (error) => {
          console.error("API error, ", error);
        }
      );
    } catch (error) {
      console.error("Error while setting default language, ", error);
    }
  }
  
  onLanguageChange() {
    try {
      if (this.selectedLanguage) {
        this.auth.setLanguage(this.currentUser.id, this.selectedLanguage.shortName).subscribe(
          (response) => {
            this.translate.use(this.selectedLanguage.shortName);
            storageService.setItem("language", this.selectedLanguage.shortName);
            this.commonService.sendSetLanguageEvent();
          },
          (error) => {
            console.error("API error while setting the language, ", error);
          }
        );
      }
    } catch (error) {
      console.error("Error while changing the language, ", error);
    }
  }

  setCookie(){
    if(this.loginForm.value.rememberMe){
      this.cookieService.set("isChecked","true");
      this.cookieService.set("email",this.loginForm.value.email);
      this.cookieService.set("password",this.loginForm.value.password);
    }else{
          this.cookieService.delete("email");
          this.cookieService.delete("password");
          this.cookieService.delete("isChecked");
        }
  }

  getCookiesData(){
  this.loginForm.controls["rememberMe"].setValue(this.cookieService.get("isChecked"));
  this.loginForm.controls["email"].setValue(this.cookieService.get("email"));
  this.loginForm.controls["password"].setValue(this.cookieService.get("password"));
  }
}
